import { useCallback, useContext } from 'react';
import ZoneContext from '../context/ZoneContext';
import { addModule as addModuleAction } from '../redux/actions/layout';
import { useDispatch } from 'react-redux';
import usePrivileges from './usePrivileges';
import { useGruser } from './useGruser';
export const useLayoutActions = ()=>{
    const zone = useContext(ZoneContext);
    const { gruser } = useGruser();
    const zoneName = zone === null || zone === void 0 ? void 0 : zone.name;
    const dispatch = useDispatch();
    const { canAddModule } = usePrivileges();
    const dispatchAddModule = useCallback((moduleName, position)=>dispatch(addModuleAction(gruser, {
            zoneName,
            moduleName,
            position
        })), [
        dispatch,
        zoneName
    ]);
    const addModule = canAddModule ? dispatchAddModule : undefined;
    return {
        canAddModule,
        addModule
    };
};
